export default {
  markDay: '下午好，今天是你加入鹅厂的第 100 天',
  personalInfo: {
    title: '个人信息',
    position: '港澳业务拓展组员工 直客销售 ',
    desc: {
      phone: '座机',
      mobile: '手机',
      seat: '座位',
      email: '邮箱',
      position: '职位',
      leader: '上级',
      entity: '主体',
      joinDay: '入职时间',
      group: '所属团队',
    },
  },
  profile: {
    title: '个人中心',
    welcome: '欢迎回来，祝您工作愉快',
    accountInfo: '账户信息',
    readOnly: '信息仅展示，不可修改',
    username: '账号',
    nickname: '昵称',
    telephone: '手机号',
    email: '邮箱',
    role: '角色',
    permissions: '权限数量',
    permUnit: '项权限',
    andMore: '等共 {count} 项',
    lastLogin: '最近登录',
    permissionInfo: '权限列表',
    systemInfo: '系统信息',
    systemName: '系统名称',
    accountType: '账户类型',
    adminAccount: '管理平台账户',
  },
  visitData: '首页访问数据',
  contentList: '内容列表',
  teamMember: '团队成员',
  serviceProduction: '服务产品',
};
